"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Shimmer_1 = __importDefault(require("components/design-system/shimmer/Shimmer"));
require("./ProjectCardSkeleton.scss");
const ProjectCardSkeleton = () => {
    return (react_1.default.createElement("div", { className: "project-skeleton-wrapper w-full grid" },
        react_1.default.createElement("div", { className: "project-skeleton-card py-[16px] px-[16px] border-gray rounded-[4px]" },
            react_1.default.createElement("div", { className: "project-skeleton-header" },
                react_1.default.createElement(Shimmer_1.default, { width: "30%", height: "20px", customClass: "rounded" })),
            react_1.default.createElement("div", { className: "project-skeleton-label mt-[28px] mb-[32px]" },
                react_1.default.createElement("span", { className: "mr-[8px]" },
                    react_1.default.createElement(Shimmer_1.default, { width: "35%", height: "20px", customClass: "rounded" })),
                react_1.default.createElement(Shimmer_1.default, { width: "35%", height: "20px", customClass: "rounded" })),
            react_1.default.createElement("div", { className: "project-skeleton-bar" },
                react_1.default.createElement(Shimmer_1.default, { width: "90%", height: "20px", circle: true })),
            react_1.default.createElement("div", { className: "project-skeleton-profile mt-[10px]" },
                react_1.default.createElement(Shimmer_1.default, { width: "28px", height: "28px", circle: true, align: "horizontal", count: 3 })))));
};
exports.default = ProjectCardSkeleton;
